import React, {useState, useEffect, useContext} from "react";
import { navigate } from "gatsby";
import UniversalHeader from "@airasia/phoenix-widgets/widgets/UniversalHeader";
import {data as uhfData} from "../../testData/uhfHeader";
import { fireGtmEvent } from "../../utils/function";
import { GlobalContext } from "../../functions"
import axios from "axios";
import _ from "lodash";
import { getCookie } from "@airasia/phoenix-widgets/widgets/FlightSearchWidget/utils";
import { kongEndpoints } from "./constants";
import PhoenixUtil from '../PhoenixUtilities/utilities';
import Styled from "styled-components"


const StyledHeader = Styled.header`
    & [class^=UniversalHeader__ImageContainer]{
        justify-content: center;
    }
`;


const airAsiaLogoUrl = "https://static.airasia.com/design/logos/airasia-airlines-logo.png";
const moveLogoUrl = "https://static.airasia.com/design/logos/airasia-move-light.svg";

const fixUhfData = (improperData, logoURL=moveLogoUrl) => {
    let temp = _.cloneDeep(improperData);
    temp.components = temp.components.reduce((mainAcc, item, idx)=>{
        let compItem = item.data.reduce((acc,item,idx)=>{
            let temp = {...item};
            if(item.type==="logo"){
                temp.iconUrl = logoURL;
                temp.direction = "left";
            }
            acc.push(temp);
            return acc;
        },[])
        mainAcc.push({data: compItem});
        return mainAcc;
    },[]);
    // console.log("from fixUhfdata --- ", improperData, temp);
    return temp;
};


const getUhfData = async (lang="en-gb", isChinaDomain, isHome) => {
    let headerPath = "universalheader";
    if (isChinaDomain) { // https://static.airasia.com/cosmos/uhf/universalfootercn/en-gb/file.json
        headerPath = "universalheader";
    }
    let reqRes = await fetch(["dev", "stg"].includes(process.env.GATSBY_ENV) ? `https://static.stgairasia.com/cosmos/uhf/${headerPath}/${lang}/file.json` : `https://static.airasia.com/cosmos/uhf/${headerPath}/${lang}/file.json`);
    let responseData = await reqRes.json();
    // responseData.components[0].data.push( {
    //     "type": "logo",
    //     "id": "aalogo",
    //     "iconUrl": "https://static.airasia.com/design/logos/airasia_airline_logo.svg",
    //     "iconName": "",
    //     "label": "",
    //     "redirectUrl": "https://www.airasia.com/en/gb",
    //     "direction": "left",
    //     "newTab": "FALSE",
    //     "showInMobilePane": "FALSE"
    //   })

    if(isHome){
        return fixUhfData(responseData, airAsiaLogoUrl);
    }

    return responseData
  }




const getKongUrl = (str) => {
    if(_.isEmpty(str))
        return "https://k.airasia.com"
    else
        return str;
};


const NavBar = (props) => {

    // const tempData["defaultLocale"] = uhfData;
    const globalContext = useContext(GlobalContext);
    const [dataUHF, setDataUHF] = useState(fixUhfData(uhfData, props.isHome ? airAsiaLogoUrl : moveLogoUrl));
    const isChinaDomain = PhoenixUtil.isChinaDomainName();

    useEffect(() => {
        (async ()=>{
            if(typeof(window) !== "undefined"){
    
                let tempCurrency = getCookie("uhfCurrency");
                let tempDataUHF = {};
    
                await getUhfData(props?.locale || "en-gb", isChinaDomain, props?.isHome).then(res => {
                    tempDataUHF = _.cloneDeep(res);
                    // console.log("logging --- ", tempDataUHF)
                    setDataUHF(tempDataUHF);
                }).catch(err => {
                    console.error("Error setting uhf data -- ", err);
                });
    
                if(_.isEmpty(tempCurrency)){
                    axios.get("https://t.airasia.com/nearestairport/airport/user").then(res => {
                        let airport = _.get(res, "data.airport[0]", "KUL");
                        return airport
                    }).then(airport => {
                        axios.get(`${getKongUrl(kongEndpoints[process.env.GATSBY_ENV || process.env.NODE_ENV])}/basecurrency/${airport}`).then(res => {
    
                            
                            let respCurrency = _.get(res, "data", "");
                            
                            let isAvailableInCurrencyList = _.some(_.get(tempDataUHF, "currencyList[0].data", []), x => x["shortform"]===respCurrency);
                            console.log("cookie --- uhfCurrency", getCookie("uhfCurrency"), res, tempDataUHF, respCurrency, isAvailableInCurrencyList);
    
                            if(!isAvailableInCurrencyList){
                                respCurrency = "MYR";
                            }
    
                            document.cookie = `uhfCurrency=${respCurrency}; expires=43200; path=/;`
                            globalContext.updateState({...globalContext.state, currency: respCurrency}); 
    
                        }).catch(err => {
                            console.error(err);
                        })
                    }).catch(err => {
                        console.error(err);
                    })
                }
    
    
                
    
                window.addEventListener('uhfLocaleChange', (e) => { 
                    let tempLocale = e.detail;
                    let pathNameSplitted = window.location.pathname.split("/");
                    let langCodesArray = pathNameSplitted.filter(x => x.length===2);
                    let urlLocale = langCodesArray.length === 2 ? `${langCodesArray[0]}-${langCodesArray[1]}` : "en-gb";
                    globalContext.updateState({...globalContext.state, lang: tempLocale}); 
                    console.log("uhfLocaleChange ---- " , e);
                    if(tempLocale !== urlLocale){
                        let urlPrefix = "";
                        if(urlLocale !== "en-gb"){
                            urlPrefix = window.location.pathname.replace(`/${langCodesArray[0]}/${langCodesArray[1]}`, tempLocale === "en-gb" ? "" :tempLocale.replace("", "/").replace("-", "/"));
                        }else{
                            let splicedNameArray = [...pathNameSplitted]
                            // splicedNameArray.splice(1, 2);
                            urlPrefix = tempLocale === "en-gb" ? `${splicedNameArray.join("/")}` :`${tempLocale.replace("", "/").replace("-", "/")}${splicedNameArray.join("/")}`; 
                        }
                        urlPrefix = urlPrefix.replace("/flights", "");
                        console.log("urlPrefix --- ", urlPrefix)
                        navigate(!urlPrefix ? "/" : urlPrefix);
                    }
                 });
                window.addEventListener('uhfCurrencyChange', (e) => { globalContext.updateState({...globalContext.state, currency: e.detail}); console.log("uhfCurrencyChange ----- " ,e); });
            }
            
            return (()=>{
                if(typeof(window) !== "undefined"){
                    window.removeEventListener('uhfLocaleChange', (e) => { console.log(e); });
                    window.removeEventListener('uhfCurrencyChange', (e) => { console.log(e); });
                }
            })
        })();
    }, [setDataUHF])

    return (
        <StyledHeader>
            <UniversalHeader 
            locale={props?.locale}
            currency={props?.currency}
            autoViewportOnLoad
            // currency={""}
            data={dataUHF}
            fireGtm={fireGtmEvent}
            onUserLoginStatus={e => console.log(e)}
            environment={["dev", "stg"].includes(process.env.GATSBY_ENV) ? "staging" : "production"}
            loginConfig={{
                HideLoginIconForMobile: false,
                enableBigPoints: true,
                enableFavoriteMembers: false,
                reloadOnLogin: true,
                shouldSetCookie: true
              }}
    
          />
        </StyledHeader>
    )
}

export default NavBar;
